// extracted by mini-css-extract-plugin
module.exports = {"arrows":"v_bJ","arrows__right":"v_bK","arrows__left":"v_bL"};